// extracted by mini-css-extract-plugin
module.exports = {"WinMessage":"WinMessage_WinMessage__3lPWM","hidden":"WinMessage_hidden__KeXwp"};